import main from './list.svg';
import active from './list-filled.svg';
import disabled from './list-gestalt.svg';

export default { main, active, disabled };
